export default __webpack_public_path__ + "static/media/eye.aab9e317.png";